/** WKWebView / 旧版 Safari 常不支持可动画的 @property + color-mix */
export const supportsOnboardingAccentColorMix = (): boolean => {
  if (typeof CSS === "undefined" || typeof CSS.supports !== "function") {
    return false;
  }
  return CSS.supports("color", "color-mix(in srgb, red, blue)");
};
